(()=> {
  // 商品データ取得
  let mainProduct;
  const pathnameparts = window.location.pathname.split('/');
  const mainHandle = pathnameparts[pathnameparts.length - 1];
  fetch(`/products/${mainHandle}.js`)
    .then(res => res.json())
    .then(data => {
      mainProduct = data;
    })
    .catch(error => {
    });
  let productUnpacking;
  fetch('/products/unpacking.js')
    .then(res => res.json())
    .then(data => {
      productUnpacking = data;
    })
    .catch(error => {
    });
  let productEnrg;
  fetch('/products/e-nrg_for_product.js')
    .then(res => res.json())
    .then(data => {
      productEnrg = data;
    })
    .catch(error => {
    });
  let productAdapter;
  fetch('/products/e-nrg-bottle-adaptor.js')
    .then(res => res.json())
    .then(data => {
      productAdapter = data;
    })
    .catch(error => {
    });
  
  // 選択中のvariantId取得
  function getCurrentVariantId() {
    let url = new URL(window.location.href);
    let param = url.searchParams.get('variant');
    if (param) {
      return param;
    }
    const selectElement = document.querySelector('select.product-selct-variant');
    if (selectElement) {
      return selectElement.value;
    }
    return '';
  }

  // 画像サイズ変更用ユーティリティ関数
  function getSizedImageUrl(src, size) {
    let match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match !== null) {
      let prefix = src.split(match[0]);
      let suffix = match[0];
      return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
    }
    return src;
  }

  // ポップアップ用商品データ生成
  function getBreakdownDOM(product, variantId, isUseVariantImg, isDisplayOption) {
    let selectVariant;
    product.variants.forEach(variant => {
      if (variant.id == variantId) {
        selectVariant = variant;
      }
    });
    let optionList = '';
    if (variantId && isDisplayOption) {
      let optionListElements = '';
      product.options.forEach((option, index) => {
        if (option.name != 'Title') {
          optionListElements += `<li class="cart_popup_product_list_item_detail_option_list_item">${option.name} : ${selectVariant.options[index]}</li>`;
        }
      });
      if (optionListElements) {
        optionList = `<ul class="cart_popup_product_list_item_detail_option_list">${optionListElements}</ul>`;
      }
    }
    let imageSrc = '';
    let imageUrl = '';
    if (variantId && isUseVariantImg) {
      if (selectVariant.featured_image) {
        imageSrc = selectVariant.featured_image.src;
      } else {
        imageSrc = product.featured_image;
      }
    } else {
      imageSrc = product.featured_image;
    }
    imageUrl = getSizedImageUrl(imageSrc, '200x');

    let price = '';
    if (variantId) {
      price = selectVariant.price;
    } else {
      price = product.price;
    }
    return `
      <li class="cart_popup_product_list_item js-cart-popup-product-list-item" id="js-cart-popup-product-list-item-${product.id}">
        <div class="cart_popup_product_list_item_left_wrapper">
          <img src="${imageUrl}" class="cart_popup_product_list_item_image">
          <div class="cart_popup_product_list_item_detail">
            <h3 class="cart_popup_product_list_item_detail_title">${product.title}</h3>
            ${optionList}
          </div>
        </div>
        <p>¥${(price / 100).toLocaleString()}<span class="product_detail_tax_included">（税込）</span></p>
      </li>
    `;
  }

  // ポップアップ用商品データ生成(関連商品)
  function getRelatedDOM(id, title, price, image, option) {
    let optionList = '';
    if (option) {
      optionList = `<ul class="cart_popup_product_list_item_detail_option_list"><li class="cart_popup_product_list_item_detail_option_list_item">${option}</li></ul>`;
    }
    return `
      <li class="cart_popup_product_list_item js-cart-popup-product-list-item" id="js-cart-popup-product-list-item-${id}">
        <div class="cart_popup_product_list_item_left_wrapper">
          <img src="${image}" class="cart_popup_product_list_item_image">
          <div class="cart_popup_product_list_item_detail">
            <h3 class="cart_popup_product_list_item_detail_title">${title}</h3>
            ${optionList}
          </div>
        </div>
        <p>¥${(price / 100).toLocaleString()}<span class="product_detail_tax_included">（税込）</span></p>
      </li>
    `;
  }
    
  document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.getElementById("cart-breakdown-toggle");
    const contentBox = document.getElementById("cart-breakdown-content");
    const itemsBox = contentBox ? contentBox.querySelector(".cart_subtotal_breakdown_container_items") : null;

    if (toggle) {
      toggle.addEventListener("click", function () {
        if (contentBox.style.display === "none" || contentBox.style.display === "") {
          itemsBox.innerHTML = ""; // 中身リセット
          let productList = "";

          // 商品本体
          const mainVariantId = getCurrentVariantId();
          productList += getBreakdownDOM(mainProduct, mainVariantId, true, true);

          // 開梱設置
          const unpackingSelected = $("#select_unpacking option:selected");
          if (unpackingSelected && unpackingSelected.val()) {
            productList += getBreakdownDOM(productUnpacking, unpackingSelected.val(), false, true);
          }

          // e-NRG
          const enrgSelected = $("#select_adapter option:selected");
          if (enrgSelected && enrgSelected.val()) {
            productList += getBreakdownDOM(productEnrg, enrgSelected.val(), false, true);
          }
          
          // アダプター
          const adapterSlected = $("#select_enrg option:selected");
          if (adapterSlected && adapterSlected.val()) {
            productList += getBreakdownDOM(productAdapter, adapterSlected.val(), false, false);
          }

          // 関連商品
          const checkedItems = document.querySelectorAll('.new_product_add_accessory_list_checkbox:checked');
          checkedItems.forEach(checkbox => {
            const idValue = checkbox ? checkbox.value : '';

            const container = checkbox.closest('.new_product_add_accessory_list_item');
            if (!container) {
              return;
            }
          
            const img = container.querySelector('.new_product_add_accessory_list_item_image');
            const imageSrc = img ? img.src : '';
          
            const titleEl = container.querySelector('.new_product_add_accessory_list_item_title');
            let productName = '';
            let optionName = '';
            if (titleEl) {
              const span = titleEl.querySelector('span');
              optionName = span ? span.textContent.trim() : '';
              if (span) {
                span.remove();
              }
              productName = titleEl.textContent.trim();
              if (span) {
                titleEl.appendChild(span);
              }
            }
          
            // 価格
            const priceInput = container.querySelector('input[name="related-product-price"]');
            const priceValue = priceInput ? priceInput.value : '';

            productList += getRelatedDOM(idValue, productName, priceValue, imageSrc, optionName);
          });


          itemsBox.innerHTML = productList;
          contentBox.style.display = "block";

        } else {
          contentBox.style.display = "none"; // トグルで非表示
        }
      });
    }
  });
})();